import i18next, { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { useEffect, useState } from 'react';
import { initReactI18next } from 'react-i18next';

const useI18nInit = (initProps: InitOptions) => {
	const [i18nInstance] = useState(i18next.createInstance());
	const init = async () => {
		//NOTE: LanguageDetector should be removed incase ms fabric api return selected language.
		i18nInstance.use(LanguageDetector).use(initReactI18next).init(initProps);
	};
	useEffect(() => {
		init();
	}, []);
	return i18nInstance;
};

export default useI18nInit;
